import { type ReactNode, useEffect, useState } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * This component is used to render a component only on the client side.
 * It is used to avoid hydration errors and prevent something from being rendered on the server.
 */
const ClientOnly = ({ children, fallback = null }: Props) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export { ClientOnly };
